/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="login.module.ts" />

module Meevo.Plugins.Login {

    export class LoginDataService {

        constructor($http: angular.IHttpService) {

        }
        
        authenticate(userName: string, password: string, passCode?: string, passKey?: string): AuthenticationResponse {

            //TODO: Implement API calls once backend is ready
            // would change from returning an AuthenticationResponse to a promise

            //TODO: Implement Authentication Status Enum
            // 1 = Valid
            // 2 = Invalid
            
            if (userName === "dan" && password === "Welcome1**") {
                return <AuthenticationResponse>{
                    identity: <Meevo.Components.Common.IIdentity>
                    {
                        //locationId: 13401,
                        //languageId: 1,
                        //userGlobalId: Guid.empty,
                        //sessionId: Guid.empty,
                        //username: userName,
                        //workstationId: 1
                    },
                    status: 1
                };
            };
            
            if (userName === "super" && password === "super08*") {
                if (passCode === "148507" && passKey === "ABCD1234") {
                    return <AuthenticationResponse>{
                        identity: <Meevo.Components.Common.IIdentity>
                        {
                            //locationId: 13401,
                            //languageId: 1,
                            //userGlobalId: Guid.empty,
                            //sessionId: Guid.empty,
                            //username: userName,
                            //workstationId: 1
                        },
                        status: 1
                    };
                }
            };

            return <AuthenticationResponse>{
                identity: null,
                status: 2
            };
        }

        getPassCode(): string {
            //TODO: Implement Pass Code generation - Talk to Jon Rosenbaum

            return "148507";
        }

        getWorkStations(): WorkStation[] {
            
            return [
                <WorkStation>{
                    id: 1,
                    displayName: "Default Workstation"
                },
                <WorkStation>{
                    id: 2,
                    displayName: "Front Desk"
                },
                <WorkStation>{
                    id: 3,
                    displayName: "Workstation 1"
                },
                <WorkStation>{
                    id: 4,
                    displayName: "Workstation 2"
                }
            ];
        }

        static factory(): Function {
            let dataSvc = ($http: angular.IHttpService) => {
                return new LoginDataService($http);
            }

            dataSvc.$inject = ["$http"];
            return dataSvc;
        }

    }

    angular.module("meevo.plugins.login")
        .factory("meevo.plugins.login.LoginDataService", LoginDataService.factory());
}